<ng-container>
  <div class="dashboard__wrapper">
    <iq-central-front-end-navbar></iq-central-front-end-navbar>
    <div class="main-content__wrapper">
      <div class="title__wrapper">
        <div class="row align-items-center g-2">
          <div class="col-12 col-md-3">
            <h6 class="page__title mb-0">Dashboard</h6>
          </div>

          <div class="col-12 col-md-4 form-group mb-0" *rbacAllow="[true]">
            <input
              type="text"
              matInput
              [formControl]="myControl"
              [matAutocomplete]="auto"
              class="form-control"
              placeholder="Select a staff"
            />

            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayFn"
              (optionSelected)="onStaffSelected($event)"
            >
              <mat-option [value]="staff" *ngFor="let staff of totalStaffs">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="">{{ staff?.user?.fullName }}</span>
                  <small class="text-muted">{{
                    staff?.department?.name
                  }}</small>
                </div></mat-option
              >
            </mat-autocomplete>
          </div>

          <div
            class="col-12 col-md-4 d-flex my-3 my-sm-0 justify-content-sm-end"
          >
            <app-filter
              (filterEvent)="filterDashboard($event)"
              [showModified]="false"
              [showUsers]="user.admin"
            ></app-filter>
          </div>

          <div class="col-12 col-md-1">
            <div
              *ngIf="
                isFetchingUsers || isFetchingDashboard || isFetchingDepartments
              "
              class="loading-indicator"
            >
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          </div>
        </div>
      </div>
      <div class="dash-cards__wrapper mt-3">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <div class="card py-2 px-3 justify-content-start">
              <img src="/assets/icons/enrolled.svg" alt="" />
              <div class="c-text px-4">
                <h6 class="mt-3 mb-0">
                  {{ dashboardDeets?.totalEnrolledCourses }}
                </h6>
                <p>Enrolled</p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-3" *rbacAllow="[true]">
            <div class="card py-2 px-3 justify-content-start">
              <img src="/assets/icons/courses.svg" alt="" />
              <div class="c-text px-4">
                <h6 class="mt-3 mb-0">{{ dashboardDeets?.totalCourses }}</h6>
                <p>Courses</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3" *rbacAllow="[false]">
            <div class="card py-2 px-3 justify-content-start">
              <img src="/assets/icons/courses.svg" alt="" />
              <div class="c-text px-4">
                <h6 class="mt-3 mb-0">
                  {{ dashboardDeets?.totalAssignedCourses }}
                </h6>
                <p>Assigned Courses</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3" *rbacAllow="[true]">
            <div class="card py-2 px-3 justify-content-start">
              <img src="/assets/icons/active-course.svg" alt="" />
              <div class="c-text px-4">
                <h6 class="mt-3 mb-0">
                  {{ dashboardDeets?.totalLearningPaths }}
                </h6>
                <p>Learning Paths</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3" *rbacAllow="[false]">
            <div class="card py-2 px-3 justify-content-start">
              <img src="/assets/icons/active-course.svg" alt="" />
              <div class="c-text px-4">
                <h6 class="mt-3 mb-0">
                  {{ dashboardDeets?.totalAssignedLearningPaths }}
                </h6>
                <p>Assigned Paths</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <div class="card py-2 px-3 justify-content-start">
              <img src="/assets/icons/compliance.svg" alt="" />
              <div class="c-text px-4">
                <h6 class="mt-3 mb-0">
                  <!-- {{
                    dashboardDeets?.totalCourses
                      ? ((totalStaffs?.paginationInfo?.totalElements /
                          dashboardDeets?.totalCourses) *
                          100 | number: '1.0-0') + '%'
                      : 0 + '%'
                  }} -->
                  0%
                </h6>
                <p>Overall Compliance</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sections__wrapper my-5">
        <div class="row mt-2">
          <div
            class="col-12 col-md-7 list-view__wrapper table-responsive"
            *rbacAllow="[true]"
          >
            <div class="rc-title__wrapper d-flex justify-content-between">
              <p class="mt-1">Compliance Levels</p>
              <button
                class="btn btn-secondary btn-sm ml-4"
                [routerLink]="['/setting/structure']"
              >
                View All
              </button>
            </div>
            <table class="table no-wrap" id="myTable">
              <tbody>
                <div *ngIf="departments?.length == 0">
                  <div
                    class="d-flex align-items-center m-3 justify-content-center"
                  >
                    <img
                      src="assets/images/no-data.svg"
                      alt=""
                      style="width: 30%"
                    />
                  </div>
                  <div
                    class="font20 d-flex align-items-center m-auto justify-content-center"
                  >
                    <img src="assets/icons/info.png" alt="" />
                    <div class="ml-3 font-light">
                      You have no compliance level.
                    </div>
                  </div>
                </div>
                <tr class="my-5" *ngFor="let level of departments">
                  <td class="mx-3 no-wrap">
                    <div
                      class="mx-2 d-flex justify-content-start align-items-center"
                    >
                      <div>
                        <h5 class="header mb-0">DEPARTMENT</h5>
                        <p class="value mt-1">{{ level?.name }}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      class="mx-2 d-flex justify-content-start align-items-center"
                    >
                      <div class="mx-2">
                        <p class="header mb-0">ASSIGNED</p>
                        <p class="value mt-1 text-center">
                          {{ level.numberOfUsers }}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="mx-2">
                      <div class="font24">
                        {{
                          ((dashboardDeets / level.numberOfUsers) * 100
                            | number : '1.0-0') +
                            '%' ==
                          null
                            ? ((dashboardDeets / level.numberOfUsers) * 100
                                | number : '1.0-0') + '%'
                            : '0%'
                        }}
                      </div>
                    </div>
                  </td>
                  <!-- <td>
                    <button class="btn btn-outline-secondary btn-sm">
                      View
                    </button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="col-12 col-lg-7 list-view__wrapper table-responsive"
            *rbacAllow="[false]"
          >
            <div class="rc-title__wrapper d-flex justify-content-between">
              <p class="mt-1">In Progress Courses</p>
              <button
                class="btn btn-secondary btn-sm ml-4"
                [routerLink]="['/learning']"
                *ngIf="dashboardDeets?.enrolledCourses.length > 0"
              >
                View All
              </button>
            </div>
            <div
              *ngIf="dashboardDeets?.enrolledCourses.length == 0"
              class="text-center mt-2"
            >
              <div class="font20 d-flex align-items-center m-auto">
                <img src="assets/icons/info.png" alt="" />
                <div class="ml-3 font-light">
                  You have no courses in progress.
                </div>
              </div>
            </div>
            <table class="table no-wrap" id="myTable">
              <tbody>
                <tr
                  class="my-5"
                  *ngFor="
                    let course of dashboardDeets?.enrolledCourses
                      | slice : 0 : 4
                  "
                  [routerLink]="[
                    '/courses/course-details',
                    course?.course?.code
                  ]"
                >
                  <td class="mx-3 no-wrap">
                    <div
                      class="mx-2 d-flex justify-content-start align-items-center"
                    >
                      <div>
                        <h5 class="header mb-0">Title</h5>
                        <p class="value mt-1">{{ course?.course?.title }}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      class="mx-2 d-flex justify-content-start align-items-center"
                    >
                      <div class="mx-2">
                        <p class="header mb-0">LEVEl</p>
                        <p class="value mt-1">{{ course?.course?.level }}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="mx-2">
                      <p class="header mb-0">PROGRESS</p>
                      <progress
                        class="progressBar"
                        value="{{ course?.course?.progress }}"
                        max="100"
                        class="mt-1"
                      ></progress>
                    </div>
                  </td>
                  <td>
                    <button class="btn btn-outline-secondary btn-sm">
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="goal-card mt-5 px-4 pb-5 pt-3 col-12 col-lg-5"
            *rbacAllow="[false]"
          >
            <h5 class="font20">Weekly Goal</h5>
            <hr />
            <div
              id="edit_button"
              class="text-right click text-blue text-bold font14 mr-4"
              (click)="toggleEdit()"
            >
              EDIT
            </div>
            <div class="d-flex justify-content-between" *ngIf="!edit">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <div class="goal-counter">0/{{ goal ? goal : 0 }}</div>
              </div>
              <div></div>
              <div class="col-lg-8 col-md-8 col-sm-6 my-auto">
                <div class="font-light font14">
                  You’ve got this! Start learning to reach your goal. <br />
                  Last Week: 0 minutes
                </div>
              </div>
            </div>
            <div *ngIf="edit">
              <div class="px-3">
                <h4 class="mt-1 mb-0">SET A WEEKLY GOAL</h4>
                <p class="font-light">
                  Track your progress and stay motivated to hit your weekly
                  goal.
                </p>
              </div>
              <form [formGroup]="weeklyGoal">
                <div class="col-sm-12 my-auto d-flex justify-content-between">
                  <select
                    name=""
                    id=""
                    class="goal-select mr-2"
                    formControlName="goal"
                  >
                    <option value="1">1 course a week</option>
                    <option value="2">2 courses a week</option>
                    <option value="3">3 courses a week</option>
                    <option value="4">4 courses a week</option>
                  </select>
                  <button class="btn save" (click)="onSubmit()">Save</button>
                </div>
              </form>
            </div>
          </div>
          <div class="col-12 col-md-5 card-view__wrapper" *rbacAllow="[true]">
            <div class="mb-4">
              <h5>Pass Ratio</h5>
            </div>
            <div class="card my-2">
              <div class="card-body">
                <div class="main-content">
                  <div
                    *ngIf="
                      dashboardDeets?.totalAssignedCourses == 0 &&
                      dashboardDeets?.totalAssignedLearningPaths == 0 &&
                      dashboardDeets?.totalEnrolledCourses == 0
                    "
                  >
                    <div class="d-flex align-items-center m-3">
                      <img
                        src="assets/images/chart.svg"
                        alt=""
                        style="width: 100%"
                      />
                    </div>
                    <div class="font20 d-flex align-items-center m-auto">
                      <img src="assets/icons/info.png" alt="" />
                      <div class="ml-3 font-light">
                        You have no chart available.
                      </div>
                    </div>
                  </div>
                  <div
                    id="chart"
                    *ngIf="
                      dashboardDeets?.totalAssignedCourses != 0 ||
                      dashboardDeets?.totalAssignedLearningPaths != 0 ||
                      dashboardDeets?.totalEnrolledCourses != 0
                    "
                  >
                    <apx-chart
                      #chartObj
                      [series]="chartOptions.series"
                      [chart]="chartOptions.chart"
                      [labels]="chartOptions.labels"
                      [responsive]="chartOptions.responsive"
                      [colors]="chartOptions.colors"
                    ></apx-chart>
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-around">
                <img src="/assets/icons/red-dot.svg" alt="" />
                <div class="one-item mx-2">
                  <span>Assigned Courses</span>
                </div>
                <img src="/assets/icons/orange-dot.svg" alt="" />
                <div class="one-item mx-2">
                  <span>Learning Path</span>
                </div>
                <img src="/assets/icons/green-dot.svg" alt="" />
                <div class="one-item mx-2">
                  <span>Enrolled Courses</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sections__wrapper my-4">
        <div class="rc-title__wrapper d-flex justify-content-start">
          <p class="mt-1">Past Due</p>
          <!-- <button class="btn btn-secondary btn-sm ml-4">View All</button> -->
        </div>
        <div class="row mt-3 section-content" *rbacAllow="[true]">
          <div
            *ngIf="dashboardDeets?.dueUsers.length == 0"
            class="text-center mt-2"
          >
            <div class="d-flex align-items-center m-3 justify-content-center">
              <img src="assets/images/no-data.svg" alt="" style="width: 30%" />
            </div>
            <div class="font20 d-flex align-items-center m-auto">
              <img src="assets/icons/info.png" alt="" />
              <div class="ml-3 font-light">No past due courses.</div>
            </div>
          </div>
          <div
            class="col-12 col-md-6 col-lg-3"
            *ngFor="let due of dashboardDeets?.dueUsers | slice : 0 : 4"
          >
            <div class="card">
              <div class="img-rating-header d-flex justify-content-start">
                <img src="{{ due?.avatarUrl }}" alt="" />
                <div class="name-rating m-3">
                  <h4 class="mb-0 mt-2">{{ due?.fullNmae }}</h4>
                  <div class="badge badge-brown">
                    {{ due?.dueDate | date }}
                  </div>
                </div>
              </div>
              <div class="mt-2 comment">
                <h6>COURSE TITLE</h6>
                <p class="my-2">
                  {{ due?.courseName }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3 section-content" *rbacAllow="[false]">
          <div
            *ngIf="dashboardDeets?.dueCourses.length == 0"
            class="text-center mt-2"
          >
            <div class="font20 d-flex align-items-center m-auto">
              <img src="assets/icons/info.png" alt="" />
              <div class="ml-3 font-light">
                You have no courses in progress.
              </div>
            </div>
          </div>
          <div
            class="col-12 col-md-6 col-lg-3 mb-3 click"
            [routerLink]="['/courses/course-details', due.code]"
            *ngFor="let due of dashboardDeets?.dueCourses | slice : 0 : 4"
          >
            <div class="bg-white">
              <div>
                <img src="{{ due?.imageUrl }}" alt="" class="w-100 courseImg" />
              </div>
              <p class="mx-4 mt-4 font-bold">
                {{ due?.title }} <br />
                <span class="text-grey font10"
                  >By: {{ due?.company?.name }}</span
                >
              </p>
              <div class="py-2 mx-4">
                <div class="progress">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [style.width]="due?.progress + '%'"
                  ></div>
                </div>
                <p class="font-light font12">{{ due?.progress }}% Complete</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper">
      <hr />
      <iq-central-front-end-footer></iq-central-front-end-footer>
    </div>
  </div>
</ng-container>
